import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/lib/auth";
import { apiRequest } from "@/lib/queryClient";
import { cashScopeKey } from "@/hooks/use-branch-cash";

export type JobPayee = { kind: "supplier"; id: string; name: string } | { kind: "user"; id: string; name: string } | { kind: "person"; name: string; phone: string };
export type JobPayees = { suppliers: { id: string; name: string; nameAr?: string | null }[]; users: { id: string; name: string }[]; people: { name: string; phone?: string | null }[] };
export function jobPayeePayload(payee: JobPayee) {
  return payee.kind === "supplier" ? { supplierId: payee.id } : payee.kind === "user" ? { payeeUserId: payee.id } : { payeeName: payee.name.trim(), payeePhone: payee.phone.trim() || undefined };
}
export function useJobPayees(search: string) {
  const { user, currentWorkspace, roles } = useAuth();
  return useQuery<JobPayees>({
    queryKey: ["branch-cash", "job-payees", ...cashScopeKey(currentWorkspace?.id, user, roles.find(r => r.id === user?.roleId)?.permissions.map(p => p.id)), search],
    queryFn: async () => (await apiRequest("GET", `/api/cash/job-payees?q=${encodeURIComponent(search)}`)).json(),
    enabled: !!user?.id && !!currentWorkspace?.id,
    staleTime: 0,
  });
}